module.exports = __webpack_public_path__ + "static/media/webCrawling.6c39a106.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Wickey/webCrawling.jpg
// module id = 374
// module chunks = 0